import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../lang/LangEnum';
import { OrderSummaryTestIds } from '../../../../../../utils/testIds/OrderSummary.testIds';
import RachelChangedValue from '../../../../../rachel/components/RachelChangedValue';
import { useTranslation } from '../../../../../translation/TranslationContext';

type TotalQuantitiesProps = {
  totals?: number;
  label: LangEnum;
  testId: OrderSummaryTestIds;
  isSuggested?: boolean;
  isStacked?: boolean;
};

const OrderSummaryTotalQuantity = ({
  totals = 0,
  label,
  testId,
  isSuggested,
  isStacked,
}: TotalQuantitiesProps) => {
  const { translate } = useTranslation();

  return (
    <Stack
      direction={isStacked ? 'column' : 'row'}
      sx={{
        alignItems: isStacked ? 'flex-start' : 'baseline',
        columnGap: 0.5,
      }}
    >
      <Typography
        noWrap
        testId={testId}
        variant="body2"
        sx={{ fontWeight: isSuggested ? 600 : undefined }}
      >
        <RachelChangedValue value={totals}>{totals}</RachelChangedValue>
      </Typography>
      <Typography noWrap variant="body2" sx={{ color: 'inherit' }}>
        {translate(label, { quantity: totals })}
      </Typography>
    </Stack>
  );
};

export default OrderSummaryTotalQuantity;
